import IPointOfView from '../interfaces/point-of-view.interface'
import not_selected_icon from '../../assets/not_active_point_of_interest.svg'
import selected_icon from '../../assets/active_point_of_interest.svg'
import dark_not_selected_icon from '../../assets/not_active_dark_point_of_interest.svg'
import dark_selected_icon from '../../assets/active_dark_point_of_interest.svg'
import styles from '../../styles.module.css'
import { useAppStore } from '../../shared/store/store'

export function PointOfViewButton({
  data,
  isSelected,
  onClick,
}: {
  data: IPointOfView
  isSelected: boolean
  onClick: (data: IPointOfView) => void
}): JSX.Element {
  const darkPointsOfView = useAppStore((state) => state.darkPointsOfView)

  return (
    <button className={styles.point_of_interest_button} onClick={() => onClick(data)}>
      {darkPointsOfView ? (
        <img
          src={isSelected ? dark_selected_icon : dark_not_selected_icon}
          alt={data.description}
        />
      ) : (
        <img src={isSelected ? selected_icon : not_selected_icon} alt={data.description} />
      )}
    </button>
  )
}
